import { lazy } from 'react';
import {
  UserOutlined,
  CheckOutlined,
  AreaChartOutlined,
  ShoppingCartOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import UserSvg from './components.js/svg/UserSvg';
import MarketView from './pages/HomeVersion/market/MarketView';

const Home = lazy(() => import('./pages/Home'));
const Orders = lazy(() => import('./pages/Orders'));
const Menu = lazy(() => import('./pages/Menu'));
const Customers = lazy(() => import('./pages/Customers'));
const Accounting = lazy(() => import('./pages/Accounting'));
const Manage = lazy(() => import('./pages/Manage'));
const Account = lazy(() => import('./pages/Account'));
const CompletedOrders = lazy(() => import('./pages/CompletedOrders'));
const Expenses = lazy(() => import('./pages/Expenses'));
const Checkout = lazy(() => import('./pages/Checkout'));
const HomeVersions = lazy(() => import('./pages/HomeVersion/HomeVersions'));
const FastCasual = lazy(() => import('./pages/HomeVersion/FastCasual'));
const PurchaseOrdersTable = lazy(() => import('./pages/PurchaseOrdersTable'));
const StockExpiry = lazy(() => import('./pages/StockExpiry'));
const KitchenViewPage = lazy(() => import('./pages/KitchenViewPage'));
const RestaurantVersion = lazy(
  () => import('./pages/HomeVersion/RestaurantVersion')
);
const Inventory = lazy(() => import('./pages/Inventory'));

const routes = [
  {
    key: Math.random(),
    path: '/checkout',
    component: Checkout,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V12.2969C3.5 11.7852 3.69615 11.2929 4.04809 10.9215L11.0481 3.53257C11.8369 2.69989 13.163 2.69989 13.9519 3.53257L20.9519 10.9215C21.3038 11.2929 21.5 11.7852 21.5 12.2969V19C21.5 20.1046 20.6046 21 19.5 21H14.5M10.5 21V15.5C10.5 15.2239 10.7239 15 11 15H14C14.2761 15 14.5 15.2239 14.5 15.5V21M10.5 21H14.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'cashier_page'
  },
  {
    key: Math.random(),
    path: '/',
    component: HomeVersions,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V12.2969C3.5 11.7852 3.69615 11.2929 4.04809 10.9215L11.0481 3.53257C11.8369 2.69989 13.163 2.69989 13.9519 3.53257L20.9519 10.9215C21.3038 11.2929 21.5 11.7852 21.5 12.2969V19C21.5 20.1046 20.6046 21 19.5 21H14.5M10.5 21V15.5C10.5 15.2239 10.7239 15 11 15H14C14.2761 15 14.5 15.2239 14.5 15.5V21M10.5 21H14.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'home'
  },
  {
    key: Math.random(),
    path: '/marketView',
    component: MarketView,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V12.2969C3.5 11.7852 3.69615 11.2929 4.04809 10.9215L11.0481 3.53257C11.8369 2.69989 13.163 2.69989 13.9519 3.53257L20.9519 10.9215C21.3038 11.2929 21.5 11.7852 21.5 12.2969V19C21.5 20.1046 20.6046 21 19.5 21H14.5M10.5 21V15.5C10.5 15.2239 10.7239 15 11 15H14C14.2761 15 14.5 15.2239 14.5 15.5V21M10.5 21H14.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'home'
  },
  {
    key: Math.random(),
    path: '/fastCasualView',
    component: FastCasual,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V12.2969C3.5 11.7852 3.69615 11.2929 4.04809 10.9215L11.0481 3.53257C11.8369 2.69989 13.163 2.69989 13.9519 3.53257L20.9519 10.9215C21.3038 11.2929 21.5 11.7852 21.5 12.2969V19C21.5 20.1046 20.6046 21 19.5 21H14.5M10.5 21V15.5C10.5 15.2239 10.7239 15 11 15H14C14.2761 15 14.5 15.2239 14.5 15.5V21M10.5 21H14.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'home'
  },
  {
    key: Math.random(),
    path: '/restaurantView',
    component: RestaurantVersion,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M10.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V12.2969C3.5 11.7852 3.69615 11.2929 4.04809 10.9215L11.0481 3.53257C11.8369 2.69989 13.163 2.69989 13.9519 3.53257L20.9519 10.9215C21.3038 11.2929 21.5 11.7852 21.5 12.2969V19C21.5 20.1046 20.6046 21 19.5 21H14.5M10.5 21V15.5C10.5 15.2239 10.7239 15 11 15H14C14.2761 15 14.5 15.2239 14.5 15.5V21M10.5 21H14.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'home'
  },
  {
    key: Math.random(),
    path: '/orders',
    component: Orders,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <rect
          x="3.5"
          y="3"
          width="18"
          height="18"
          rx="2"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
        <path
          d="M8.5 16V12"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12.5 16V10"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M16.5 16V8"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: 'current_orders'
  },
  {
    key: Math.random(),
    path: '/kitchenView',
    component: KitchenViewPage,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        fill="#fff"
        viewBox="0 0 256 256"
      >
        <path d="M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,128,56Zm32,0a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,160,56Zm94.4,35.2a8,8,0,0,0-11.2-1.6L224,104V80a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8v24L12.8,89.6a8,8,0,0,0-9.6,12.8L32,124v60a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V124l28.8-21.6A8,8,0,0,0,254.4,91.2Z"></path>
      </svg>
    ),
    label: 'kitchen_view'
  },
  {
    key: Math.random(),
    path: '/completed-orders',
    component: CompletedOrders,
    icon: <CheckOutlined />,
    label: 'order_history'
  },
  {
    key: Math.random(),
    path: '/menu',
    component: Menu,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M14.5 11H8.5M10.5 15H8.5M16.5 7H8.5M20.5 6.8V17.2C20.5 18.8802 20.5 19.7202 20.173 20.362C19.8854 20.9265 19.4265 21.3854 18.862 21.673C18.2202 22 17.3802 22 15.7 22H9.3C7.61984 22 6.77976 22 6.13803 21.673C5.57354 21.3854 5.1146 20.9265 4.82698 20.362C4.5 19.7202 4.5 18.8802 4.5 17.2V6.8C4.5 5.11984 4.5 4.27976 4.82698 3.63803C5.1146 3.07354 5.57354 2.6146 6.13803 2.32698C6.77976 2 7.61984 2 9.3 2H15.7C17.3802 2 18.2202 2 18.862 2.32698C19.4265 2.6146 19.8854 3.07354 20.173 3.63803C20.5 4.27976 20.5 5.11984 20.5 6.8Z"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    label: 'menu'
  },
  {
    key: Math.random(),
    path: '/purchaseOrders',
    component: PurchaseOrdersTable,
    icon: <ShoppingCartOutlined />,
    label: 'purchase_orders'
  },
  {
    key: Math.random(),
    path: '/stockExpiry',
    component: StockExpiry,
    icon: <LogoutOutlined />,
    label: 'stock_expiry'
  },
  {
    key: Math.random(),
    path: '/inventory',
    component: Inventory,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M3.5 10V19C3.5 20.1046 4.39543 21 5.5 21H19.5C20.6046 21 21.5 20.1046 21.5 19V10M3.5 10L5.08555 4.45056C5.33087 3.59196 6.11564 3 7.0086 3H12.5M3.5 10H12.5M21.5 10L19.9144 4.45056C19.6691 3.59195 18.8844 3 17.9914 3H12.5M21.5 10H12.5M12.5 3V10"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
        <path
          d="M6 17.5H12.5"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    label: 'inventory'
  },
  {
    key: Math.random(),
    path: '/customers',
    component: Customers,
    icon: <UserSvg />,
    label: 'customers'
  },
  {
    key: Math.random(),
    path: '/accounting',
    component: Accounting,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M12.5 22C17.8552 22 22.2272 17.7905 22.4877 12.4999C22.5013 12.2241 22.2761 12 22 12H13C12.7239 12 12.5 11.7761 12.5 11.5V2.5C12.5 2.22386 12.2759 1.9987 12.0001 2.01228C6.70948 2.27276 2.5 6.64479 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
        <path
          d="M22.4846 9.49991C22.2367 5.47997 19.02 2.26332 15.0001 2.01538C14.7245 1.99838 14.5 2.22386 14.5 2.5V9.5C14.5 9.77614 14.7239 10 15 10H22C22.2761 10 22.5016 9.77553 22.4846 9.49991Z"
          stroke="var(--seventh-color)"
          strokeWidth="1.5"
        />
      </svg>
    ),
    label: 'accounting'
  },
  {
    key: Math.random(),
    path: '/expenses',
    component: Expenses,
    icon: <AreaChartOutlined />,
    label: 'expenses'
  },

  {
    key: Math.random(),
    path: '/manage',
    component: Manage,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
      >
        <path
          d="M10.1161 2.17992e-07C10.8251 -0.000285658 11.5041 0.280614 11.9983 0.77871C12.4925 1.27681 12.7599 1.94968 12.7383 2.57766L12.7468 2.72535C12.7641 2.87079 12.8124 3.01116 12.8908 3.14054C13.0435 3.39567 13.2935 3.58081 13.5857 3.65514C13.8779 3.72947 14.1882 3.68688 14.4821 3.51839L14.646 3.4355C15.8759 2.86897 17.3511 3.31918 18.0333 4.47928L18.6465 5.52174C18.6627 5.54922 18.6769 5.57762 18.6892 5.60674L18.7461 5.71842C19.2945 6.86519 18.9043 8.22927 17.8624 8.92228L17.6051 9.08068C17.4706 9.17256 17.3585 9.29258 17.2742 9.43678C17.1218 9.69291 17.08 9.99795 17.158 10.2844C17.236 10.5708 17.4272 10.8149 17.7174 10.9793L17.8843 11.0841C18.3887 11.4297 18.753 11.9391 18.9119 12.523C19.0912 13.1817 18.995 13.8833 18.6399 14.4804L17.9803 15.557L17.8808 15.7089C17.1058 16.8008 15.6011 17.1344 14.4527 16.485L14.3166 16.4163C14.1746 16.3541 14.0214 16.3199 13.882 16.316C13.5786 16.3146 13.2872 16.432 13.0727 16.6422C12.8582 16.8524 12.7383 17.1379 12.7391 17.4698L12.731 17.6414C12.62 18.9703 11.4845 20 10.1164 20H8.88106C7.43219 20 6.25765 18.8493 6.25912 17.4753L6.25063 17.3277C6.23337 17.1822 6.18504 17.0418 6.1027 16.9057C5.95336 16.65 5.70591 16.4633 5.41538 16.3871C5.12484 16.3109 4.81529 16.3516 4.51565 16.5213L4.33762 16.6084C3.7746 16.8565 3.13953 16.9023 2.54445 16.7366C1.87306 16.5497 1.30539 16.1083 0.974125 15.5224L0.33679 14.4442L0.251966 14.2844C-0.328427 13.0841 0.126514 11.6412 1.28115 10.9875L1.38645 10.9228C1.69491 10.7137 1.87987 10.3688 1.87987 10C1.87987 9.59896 1.66149 9.22838 1.27948 9.01151L1.12449 8.91408C0.0100074 8.15476 -0.330507 6.68049 0.359895 5.50696L1.00918 4.46166C1.73128 3.23376 3.33155 2.81017 4.56235 3.50171L4.69559 3.5713C4.83141 3.63238 4.97895 3.6648 5.12101 3.66628C5.74742 3.66634 6.25775 3.17352 6.26724 2.54181L6.27575 2.3478C6.32704 1.74716 6.59307 1.1827 7.02796 0.754574C7.51861 0.27155 8.1855 2.17992e-07 8.88106 2.17992e-07H10.1161ZM10.1164 1.44774H8.88106C8.57863 1.44774 8.28866 1.56581 8.07533 1.77582C7.88625 1.96196 7.77058 2.20741 7.75028 2.43661L7.73685 2.7415C7.63339 4.07087 6.49969 5.11416 5.11326 5.11398C4.75588 5.11034 4.40355 5.03293 4.04427 4.87026L3.8519 4.77085C3.3038 4.46315 2.6049 4.64815 2.28057 5.19925L1.63128 6.24455C1.33377 6.75044 1.48256 7.39466 1.94324 7.70925L2.20395 7.871C2.92196 8.34666 3.35754 9.14295 3.35754 10C3.35754 10.8446 2.93413 11.634 2.20219 12.1296L2.04639 12.2256C1.53354 12.5163 1.33562 13.144 1.57398 13.6383L1.63027 13.7449L2.25952 14.8084C2.40728 15.0696 2.6552 15.2624 2.94842 15.344C3.20831 15.4164 3.48569 15.3964 3.70208 15.3018L3.8108 15.2497C4.41096 14.9066 5.12614 14.8126 5.79737 14.9886C6.46861 15.1645 7.04028 15.5959 7.37937 16.1768C7.56179 16.478 7.67721 16.8132 7.7219 17.1985L7.74205 17.552C7.80426 18.1145 8.29047 18.5523 8.88106 18.5523H10.1164C10.7137 18.5523 11.2099 18.1023 11.2565 17.5511L11.2621 17.4421C11.2588 16.7585 11.5345 16.1019 12.0279 15.6185C12.5212 15.1351 13.1914 14.865 13.9053 14.8686C14.2556 14.8778 14.6004 14.9547 14.9528 15.11L15.2687 15.2682C15.7647 15.4814 16.3529 15.3258 16.6511 14.9067L16.7236 14.7957L17.368 13.7436C17.5203 13.4875 17.5621 13.1824 17.4841 12.896C17.415 12.6422 17.2566 12.4207 17.0645 12.2882L16.7922 12.1195C16.2716 11.7748 15.8932 11.2563 15.7302 10.6574C15.5509 9.99866 15.6471 9.29707 15.9946 8.71262C16.1849 8.38716 16.4464 8.10733 16.7873 7.87532L16.948 7.77613C17.4601 7.4827 17.6578 6.85504 17.4212 6.35884L17.3505 6.22529L17.3378 6.19726L16.753 5.20208C16.4764 4.73175 15.9008 4.52853 15.4125 4.6891L15.3015 4.73265L15.1983 4.78415C14.6001 5.12941 13.8863 5.22736 13.2143 5.05641C12.5423 4.88546 11.9673 4.45965 11.6181 3.87616C11.4357 3.57504 11.3203 3.23984 11.2756 2.85454L11.2624 2.60249C11.2713 2.29923 11.1546 2.00536 10.9387 1.78783C10.7229 1.57029 10.4264 1.44774 10.1164 1.44774ZM9.50324 6.73182C11.3455 6.73182 12.839 8.19503 12.839 10C12.839 11.805 11.3455 13.2682 9.50324 13.2682C7.66095 13.2682 6.16748 11.805 6.16748 10C6.16748 8.19503 7.66095 6.73182 9.50324 6.73182ZM9.50324 8.17956C8.47705 8.17956 7.64516 8.9946 7.64516 10C7.64516 11.0054 8.47705 11.8204 9.50324 11.8204C10.5294 11.8204 11.3613 11.0054 11.3613 10C11.3613 8.9946 10.5294 8.17956 9.50324 8.17956Z"
          fill="var(--seventh-color)"
        />
      </svg>
    ),
    label: 'manage'
  },
  {
    key: Math.random(),
    path: '/account',
    component: Account,
    icon: <UserOutlined />,
    label: 'account'
  }
];
export default routes;
